export default "__VITE_ASSET__bc200971__"